// Responsive image helpers for Unsplash (serves WebP/AVIF via auto=format).
export const unsplash = (url, width) =>
  `${url}&auto=format&fit=crop&q=70&w=${width}`;

export const unsplashSet = (url, widths) =>
  widths.map((w) => `${unsplash(url, w)} ${w}w`).join(", ");
